import { render, staticRenderFns } from "./PingJia.vue?vue&type=template&id=6f8addee&scoped=true"
import script from "./PingJia.vue?vue&type=script&lang=js"
export * from "./PingJia.vue?vue&type=script&lang=js"
import style0 from "./PingJia.vue?vue&type=style&index=0&id=6f8addee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8addee",
  null
  
)

export default component.exports